<template lang="pug">
  .qmod-block-wrapper
    .qmod-tool-header.qmod-block-header(v-if='$slots.toolTitle')
      h2.qmod-heading.qmod-h2
        slot(name='toolTitle')
      .qmod-heading-right
        slot(name='toolTitleButtons')
    .qmod-block-wrapper-body
      slot {{$options.name}}
</template>

<script>
/* eslint-disable */
export default {
  name: "BaseBlock",
  computed: {}
};
</script>

<style lang="stylus">
{$preFix}
  &-block-header
    padding 2px 0
  &-block-wrapper
    margin 5px 0
</style>
